<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter clear-filter header-small"
      parallax-active="false"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xlarge-size-80 mx-auto"
          >
            <h1 class="title text-center">
              Find the right engineer
            </h1>
            <h4>
              Search our database of registered professional ASEAN Engineers to find the help you need
            </h4>
          </div>
          <div class="md-layout-item md-size-66 md-small-100 mx-auto">\
            <md-card class="md-card-form-horizontal">
              <md-card-content>
                <form @submit.prevent="getList">
                  <div class="md-layout">

                    
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field>
                        <md-select
                            id="field"
                            v-model="field"
                            name="field"
                            @md-selected="changePlaceholderText"
                        >
                          <md-option value="aer_id">
                              AER ID
                          </md-option>
                          <md-option value="name">
                              Name
                          </md-option>
                        </md-select>
                    </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <md-input
                          v-model="searchValue"
                          :placeholder="placeholderText"
                        />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field>
                        <md-select
                            id="grade"
                            v-model="grade"
                            name="grade"
                        >
                          <md-option value="any">
                              Any Grade
                          </md-option>
                          <md-option 
                            v-for="item in grades"
                            :key="item.code"
                            :label="item.code"
                            :value="item.code">
                              {{item.code}}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field>
                        <md-select
                            id="country"
                            v-model="country"
                            name="country"
                        >
                          <md-option value="any">
                              Any Country
                          </md-option>
                          <md-option 
                            v-for="item in countries"
                            :key="item.iso3"
                            :label="item.name"
                            :value="item.iso3">
                              {{item.name}}
                          </md-option>
                        </md-select>
                    </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <md-select
                            id="discipline"
                            v-model="discipline"
                            name="discipline"
                        >
                          <md-option value="any">
                              Any Discipline
                          </md-option>
                          <md-option 
                            v-for="item in disciplines"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                              {{item.name}}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-button
                        type="submit"
                        class="md-primary md-block"
                      >
                        Search
                      </md-button>
                    </div>
                  </div>
                </form>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </parallax>
    <div
      id="main-panel"
      class="main main-raised"
    >
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-100 md-small-size-100 mx-auto"
              v-show="(total >= 0)"
            >
                <h2 class="title">
                  Search Results
                </h2>
                <div class="md-layout-item md-size-100" style="padding: 0; margin: 0;">
                  <md-progress-bar md-mode="indeterminate" v-show="showProgressBar" class="md-primary"></md-progress-bar>
                </div>
                <p>
                  Found {{total | formatNumber}} results
                </p>
              <transition name="fade">
                <md-table v-model="searchResults">
                  <md-table-row>
                  </md-table-row>
                  <md-table-empty-state  style="width:100%">
                    <div v-show="!showProgressBar">
                      <span style="color: #aaa; font-size: 3rem; float: left;">
                        <i class="far fa-frown"></i>
                      </span>
                      <span v-show="!error" style="color: #999; font-size: 1.5rem; margin: 0; padding: 0.5em; float: left;">
                        Sorry, no results found
                      </span>
                      <span v-show="error" style="color: #999; font-size: 1.5rem; margin: 0; padding: 0.5em; float: left;">
                        Oops! There's an error
                      </span>
                    </div>
                  </md-table-empty-state>
                  <md-table-row slot="md-table-row" slot-scope="{item}">
                    <md-table-cell md-label="Name">
                      <router-link :to="{name: 'engineer.profile', params: {id: item.alias}}">
                        {{ item.name }}
                      </router-link>
                    </md-table-cell>
                    <md-table-cell md-label="Country">{{ item.country_info.name }}</md-table-cell>
                    <md-table-cell md-label="Membership">{{ displayGrades(item.grades) }}</md-table-cell>
                    <md-table-cell md-label="Organizations">{{ displayOrganizations(item.organizations) }}</md-table-cell>
                    <md-table-cell md-label="Discipline">{{ displayDisciplines(item.disciplines) }}</md-table-cell>
                  </md-table-row>
                </md-table>
                </transition>
                <pagination 
                  v-bind:perPage="pagination.perPage"
                  v-bind:total="total"
                  v-bind:value="pagination.currentPage"
                  @input="changePage"
                ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import _ from 'lodash';
import Mixins from "@/plugins/basicMixins";
import {Pagination} from "@/components";

export default {
    name: "FindEngineer",
    components: {
      Pagination
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "find-engineer-page",
    props: {
        image: {
            type: String,
            default: require("@/assets/img/hero2.jpg")
        }
    },
    data() {
      return {
        field: "aer_id",
        country: "any",
        countries: [],
        discipline: "any",
        disciplines: [],
        grade: "any",
        grades: [],
        placeholderText: "Enter AER ID",
        searchValue: "",
        searchResults: [
        ],
        total: -1,
        showProgressBar: false,
        pagination: {
          perPage: 15,
          currentPage: 1,
          perPageOptions: [10, 25, 50,100],
        },
        error: false,
      };
    },
    created() {
      this.grades = this.$store.getters["options/grades"];
      this.disciplines = this.$store.getters["options/disciplines"];
      this.countries = this.$store.getters["options/countries"];

      let parameters = this.$route.query;
      if ( parameters ) { 
        if ( parameters.field && parameters.searchValue ) {
          this.field = parameters.field;
          this.searchValue = parameters.searchValue;
        }
        this.country = parameters.country ?? "any";
        this.grade = parameters.grade ?? "any";
        this.discipline = parameters.discipline ?? "any";

        this.getList();
      }


      return;
    },
    mounted() {
    },
    beforeDestroy() {
    },
    watch: {
      pagination: {
        handler: 'getList',
        immediate: false,
        deep: true
      },
    },
    computed: {
    },
    methods: {
      getList() {
        this.showProgressBar = true;
        let params = {
          page: {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage
          },
          ...(this.field && this.searchValue ? {field: this.field, searchValue: this.searchValue} : {}),
          ...(this.country && this.country != "any" ? {country: this.country} : {}),
          ...(this.discipline && this.discipline != "any" ? {discipline: this.discipline} : {}),
          ...(this.grade && this.grade != "any" ? {grade: this.grade} : {}),
        }

          this.$store.dispatch("engineers/list", params)
            .then(() => {
              this.searchResults = this.$store.getters["engineers/list"]
              this.total = this.$store.getters["engineers/listTotal"]

              this.showProgressBar = false;
            }).catch((e) => {
              this.showProgressBar = false;
              this.error = true;
              this.total = 0;
            });
      },
      changePage(newPage) {
        this.pagination.currentPage = newPage;
      },
      changePlaceholderText(field) {
        switch(field) {
          case 'aer_id':
            this.placeholderText = "Enter AER ID";
            break;
          case 'mheo_id':
            this.placeholderText = "Enter Member Organization ID";
            break;
          case 'name':
            this.placeholderText = "Enter Engineer Name";
            break;
          case 'specialization':
            this.placeholderText = "Enter Specialization";
            break;
          default:
        }
      },
      displayGrades(list) {
        return Array.prototype.map.call(list, s => s.grade).join(", ");
      },
      displayOrganizations(list) {
        return Array.prototype.map.call(list, s => s.organization).join(", ");
      },
      displayDisciplines(list) {
        return Array.prototype.map.call(list, s => s.name).join(", ");
      }
    }
};
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>